import { backendAPI, allocationAPI } from '../../helper/apis';

export const updatePolygons = (params) => backendAPI.put('/polygons', params);
export const updatePolygonAllocationSettings = (params, id) => allocationAPI.put(`/polygons/${id}`, params);